<template>
	<div class="text-settings">
		<drag-input-unit
			:min="1"
			:max="128"
			label="Font Size"
			:value='styleJSON.fontSize' 
			icon="text-width" 
			@input="(fontSize)=>{setStyle({fontSize})}"
		/>
		<color-picker :color="styleJSON.color.value" @input="(color)=>{setStyle({color:{value:color}})}" 
			label="Цвет текста"/>
		<btn 
			icon="bold" 
			:active="styleJSON.fontWeight.value==='bold'" 
			@press="()=>{
				setStyle({fontWeight:{
					value:(styleJSON.fontWeight.value==='bold'?'normal':'bold')
				}});
			}"/>
		<btn 
			icon="italic" 
			:active="styleJSON.fontStyle.value==='italic'" 
			@press="()=>{setStyle(
					{fontStyle:{value:(styleJSON.fontStyle.value==='italic'?'normal':'italic')}}
				)
			}"/>
		<btn 
			icon="underline" 
			:active="styleJSON.textDecoration.value==='underline'" 
			@press="()=>{setStyle({
				textDecoration:{value:(styleJSON.textDecoration.value==='underline'?'none':'underline')}
			})}"/>
		<font-select @input="(fontId)=>{setStyle({fontFamily:{id:fontId}})}" />
	</div>
</template>
<script>
	import fontSelect from "./font-select.vue";
	export default {
		name:"text-settings",
		components:{fontSelect},
		props:["styleJSON","setStyle"],
		data(){
			return {
				item:"value"
			}
		}
	}
</script>
<style scoped>
</style>